export default {
      id: "md_ignition-usage",
      viewBox: "0 0 18 10",
      url: __webpack_public_path__ + "img/icons.svg#md_ignition",
      toString: function () {
        return this.url;
      }
    }